import React, { useEffect } from "react";
import { NewsFeedComponent } from "@hedgefund/shared";
import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash/debounce";
import { getPost } from "./actions";
import { getRecentChats } from "../DashBoard/actions";

const NewsFeed = () => {
  const getNewPostState = useSelector((state) => state.getNewPosts);
  const dashboardState = useSelector((state) => state.dashboard);
  const dispatch = useDispatch();

  const { loading, getPosts, postCount, pageCount } = getNewPostState;
  const { getRecentChat } = dashboardState;

  useEffect(() => {
    dispatch(
      getPost({
        page: pageCount,
        perPage: postCount,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    // let newsfeedScroll = document.getElementById("tcHeight");
    document
      ?.getElementById("newsfeedScroll")
      ?.addEventListener("scroll", () => handleScroll());
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    dispatch(getRecentChats());
  }, []);

  const handleScroll = debounce((count) => {
    if (
      document.documentElement.clientHeight +
        document.documentElement.scrollTop >=
      document.documentElement.scrollHeight - 100
    ) {
      dispatch(
        getPost({
          page: pageCount,
          perPage: postCount,
        })
      );
    }
  }, 1500);

  return (
    <NewsFeedComponent
      loading={loading}
      getPosts={getPosts}
      getRecentChat={getRecentChat}
    />
  );
};

export default NewsFeed;
